import { render, staticRenderFns } from "./Timeline.vue?vue&type=template&id=0fba8c6b&scoped=true&"
import script from "./Timeline.vue?vue&type=script&lang=ts&"
export * from "./Timeline.vue?vue&type=script&lang=ts&"
import style0 from "./Timeline.styl?vue&type=style&index=0&id=0fba8c6b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fba8c6b",
  null
  
)

export default component.exports